<ng-container *transloco="let t;">
  <app-list-view [title]="t('common.labels.recommendations')" [messages]="messages" [loading]="loading">

      <div buttons>
        <button withRight="admin.recommendation.list" pButton (click)="onReload()" type="button" icon="pi pi-refresh" class="p-button-secondary p-button-outlined p-mb-2" aria-label="{{ t('common.labels.reload_list') }}" pTooltip="{{ t('common.labels.reload_list') }}" tooltipPosition="left"></button>
        <button withRight="admin.recommendation.create" pButton (click)="onNew()" type="button" icon="pi pi-plus" label="{{ t('common.labels.new') }}" class="p-button-success p-ml-2 p-mb-2"></button>
      </div>

      <div table>
        <p-table
          [value]="recommendations"
          [paginator]="true"
          [rows]="20"
          stateStorage="local"
          stateKey="recommendation-list"
          [rowsPerPageOptions]="rowsPerPage"
          [showCurrentPageReport]="true"
          [currentPageReportTemplate]="t('common.labels.current_page_report')"
        >
          <ng-template pTemplate="header">
            <tr>
                <th pSortableColumn="name">{{ t('common.labels.name') }}
                    <p-sortIcon field="name"></p-sortIcon>
                </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-recommendation>
            <tr (click)="onOpen(recommendation)" (keyup.enter)="onOpen(recommendation)" hoverOnRight="admin.recommendation.show" tabindex="0">
              <td><span role="link">{{recommendation.getLang('name', transloco.getActiveLang())}}</span></td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td class="no-data">{{ t('common.labels.no_data') }}</td>
            </tr>
          </ng-template>
        </p-table>
      </div>

    </app-list-view>
</ng-container>
